module.exports = __webpack_public_path__ + "static/madsobel-62424cc54348de30b5d79c7a7d145623.jpg";